var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidsbabygirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.68 22.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    strokeWidth: 0,
    d: "M11.34,22.68C5.09,22.68,0,17.59,0,11.34S5.09,0,11.34,0s11.34,5.09,11.34,11.34-5.09,11.34-11.34,11.34M11.34.96C5.61.96.96,5.61.96,11.34s4.66,10.38,10.38,10.38,10.38-4.66,10.38-10.38S17.06.96,11.34.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    strokeWidth: 0,
    d: "M11.34,19.96c-4.76,0-8.62-3.87-8.62-8.62S6.58,2.71,11.34,2.71s8.62,3.87,8.62,8.62-3.87,8.62-8.62,8.62M11.34,3.67c-4.23,0-7.67,3.44-7.67,7.67s3.44,7.67,7.67,7.67,7.67-3.44,7.67-7.67-3.44-7.67-7.67-7.67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsbabygirl);
export default __webpack_public_path__ + "static/media/KIDSBABYGIRL.2f6d429c7fb8e89e85def976878eb434.svg";
export { ForwardRef as ReactComponent };